<template>
    <div class="main-content">
        <el-form class="detail-form-content" ref="ruleForm" :model="ruleForm" :rules="rules" label-width="120px" style="height:90%">
            <el-form-item label="会员服务协议" class="input" prop="context">
                <editor style="width:100%;" v-model="ruleForm.context" autocomplete="off" rows="40"
                          placeholder="请输入会员服务协议"></editor>
            </el-form-item>
            <div style="display: flex;flex-wrap: wrap;width: 100%;justify-content: center;">
                <el-button class="btn" type="primary" @click="commit()">更新</el-button>
                <el-button class="btn close" @click="close()">取消</el-button>
            </div>
        </el-form>
    </div>
</template>
<script>
    import base from '@/utils/base' // 导入配置的默认值
    import editor from '@/components/common/Editor'
    export default {
        compent:{editor},
        name:'MemberAgreementUpdate',
        data() {
            return {
                url:base.get().url,
                ruleForm: {
                    context: '',
                    id:'2'
                },
                rules:{
                    context:[{ required: true, message: '请输入会员服务协议', trigger: 'blur' }],
                },
            }
        },
        methods:{
            commit(){
                this.$refs['ruleForm'].validate((valid) => {
                    if (valid) {
                        this.$http({
                            url:  this.url+`userAgreement/`+"update",
                            method: "post",
                            data:this.ruleForm
                        }).then(({ data }) => {
                            if (data && data.code === 0) {
                                this.$message({
                                    message: "更新成功！",
                                    type: "success",
                                    duration: 1500,
                                    onClose: () => {
                                        this.close();
                                    }
                                });
                            } else {
                                this.$message.error(data.msg);
                            }
                        });
                    }
                });
            },
            loaddingData(){
                this.$http({
                    url:  this.url+"userAgreement/info/2",
                    method: "get",
                    data:this.ruleForm
                }).then(({ data }) => {
                    this.ruleForm.context = data.data.context;
                });
            }
        },
        created(){
            this.loaddingData();
        }
    }
</script>